(function (window, document, $) {

    $(document).ready(function () {

        if ($('.trainingform').length) {
            if ($('.confirm.field__wrapper--nawbetaler_emailadres').length && $('.proefles-form').length) {
                $('.steps-container .step1').removeClass('active');
                $('.steps-container .step1').addClass('done');
                $('.steps-container .step2').addClass('active');
                $('.col2').css('display', 'none');
            } else if ($('input[name="wpm-iforms-submit-confirm"]').length || $('.iforms_result_page').length) {
                $('.steps-container .step1').removeClass('active');
                $('.steps-container .step1').addClass('done');
                $('.steps-container .step2').addClass('active');
            }
            if ($('.iforms_result_page').length) {
                $('.col2').css('display', 'none');
            }
            if ($('#prijsartikel').length) {
                $('.order-content-title').html($('.field__wrapper__input--artikelkeuzes label span').html());
                $('.order-content-price .value').html($('#prijsartikel').val());
            } else if ($('#totaalbedrag').length) {
                $('.order-content-title').html($('.field__wrapper__input--artikelkeuzes label span').html());
                $('.order-content-price .value').html($('#totaalbedrag').val());
            }
        }

        //make div clickable on archive-training
        $(".page-template-archive-training .training").click(function () {
            window.location = $(this).find("a").attr("href");
            return false;
        });


        // sticky Header
        if ($('.trainingen__navigatie').length > 0) {

            stickyHeader = function () {
                var stickyOffset = $('.trainingen__navigatie').offset().top;

                $(window).scroll(function () {
                    var sticky = $('.trainingen__navigatie'),
                        scroll = $(window).scrollTop();

                    if (scroll > stickyOffset) {
                        sticky.addClass('trainingen__navigatie__fixed');
                    }
                    else {
                        sticky.removeClass('trainingen__navigatie__fixed');
                    }
                });
            }();
        }
    });

}(window, document, jQuery));
